import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

export const StyledButton = styled(Button)`
    ${setFontVariant("button", colorsPalettes.carbon[0])};

    ${SWReactIcons} {
        margin-right: 4px;
    }
`;
